import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, unref as _unref, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "modal-header" };
const _hoisted_2 = { class: "modal-title" };
const _hoisted_3 = { class: "modal-content" };
const _hoisted_4 = { class: "product-section" };
const _hoisted_5 = { class: "product-image" };
const _hoisted_6 = ["src", "alt"];
const _hoisted_7 = { class: "product-info" };
const _hoisted_8 = { class: "product-name" };
const _hoisted_9 = {
    key: 0,
    class: "product-description"
};
const _hoisted_10 = {
    key: 1,
    class: "size-selection"
};
const _hoisted_11 = { class: "selection-title" };
const _hoisted_12 = { class: "size-options" };
const _hoisted_13 = ["onClick"];
const _hoisted_14 = { class: "size-name" };
const _hoisted_15 = { class: "size-price" };
const _hoisted_16 = {
    key: 0,
    class: "ingredients-section"
};
const _hoisted_17 = { class: "selection-title" };
const _hoisted_18 = { class: "customize-mode" };
const _hoisted_19 = {
    key: 0,
    class: "base-ingredients-section"
};
const _hoisted_20 = { class: "ingredients-grid" };
const _hoisted_21 = { class: "ingredient-image" };
const _hoisted_22 = ["src", "alt"];
const _hoisted_23 = { class: "ingredient-info" };
const _hoisted_24 = { class: "ingredient-name" };
const _hoisted_25 = { class: "ingredient-base-controls" };
const _hoisted_26 = ["onClick"];
const _hoisted_27 = { class: "group-title" };
const _hoisted_28 = { class: "ingredients-grid" };
const _hoisted_29 = ["onClick"];
const _hoisted_30 = {
    key: 0,
    class: "default-badge"
};
const _hoisted_31 = { class: "ingredient-image" };
const _hoisted_32 = ["src", "alt"];
const _hoisted_33 = {
    key: 0,
    class: "removed-overlay"
};
const _hoisted_34 = { class: "ingredient-info" };
const _hoisted_35 = { class: "ingredient-name" };
const _hoisted_36 = {
    key: 0,
    class: "ingredient-price"
};
const _hoisted_37 = {
    key: 1,
    class: "ingredient-price default-price"
};
const _hoisted_38 = { class: "ingredient-controls" };
const _hoisted_39 = ["onClick"];
const _hoisted_40 = {
    key: 1,
    class: "quantity"
};
const _hoisted_41 = ["onClick"];
const _hoisted_42 = {
    key: 1,
    class: "additional-options-section"
};
const _hoisted_43 = { class: "selection-title" };
const _hoisted_44 = { class: "options-hint" };
const _hoisted_45 = { class: "additional-options-list" };
const _hoisted_46 = ["value"];
const _hoisted_47 = { class: "option-name" };
const _hoisted_48 = { class: "notes-section" };
const _hoisted_49 = ["placeholder"];
const _hoisted_50 = {
    key: 2,
    class: "modifications-summary"
};
const _hoisted_51 = { class: "modifications-list" };
const _hoisted_52 = { class: "modification-name" };
const _hoisted_53 = { class: "modification-detail" };
const _hoisted_54 = { class: "modification-price" };
const _hoisted_55 = { class: "modal-footer" };
const _hoisted_56 = { class: "quantity-section" };
const _hoisted_57 = { class: "quantity-label" };
const _hoisted_58 = { class: "quantity-controls" };
const _hoisted_59 = ["disabled"];
const _hoisted_60 = { class: "quantity-display" };
const _hoisted_61 = { class: "price-section" };
const _hoisted_62 = { class: "price-breakdown" };
const _hoisted_63 = { class: "unit-price" };
const _hoisted_64 = { class: "total-price" };
const _hoisted_65 = { class: "total-label" };
const _hoisted_66 = { class: "total-amount" };
const _hoisted_67 = ["disabled"];
import { ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { getAllIngredients, getIngredientTypes } from "@/service/api";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductCustomizationModal',
    props: {
        product: {},
        initialSelectedSize: {}
    },
    emits: ["close", "add-to-cart"],
    setup(__props, { emit: __emit }) {
        const store = useStore();
        const { t } = useI18n();
        const props = __props;
        const emit = __emit;
        const isOpen = ref(true);
        const selectedSize = ref(null);
        const customizeMode = ref("add");
        const notes = ref("");
        const quantity = ref(1);
        const selectedIngredients = ref({});
        const removedBaseIngredients = ref(new Set());
        const allIngredients = ref([]);
        const ingredientTypes = ref([]);
        const isLoadingIngredients = ref(false);
        const selectedAdditionalOption = ref(null);
        const parseAdditionalOptions = (additionnal) => {
            if (!additionnal)
                return [];
            if (Array.isArray(additionnal)) {
                return additionnal.filter((item) => (typeof item === "string" && item.trim().length > 0) ||
                    (item && typeof item === "object"));
            }
            if (typeof additionnal === "string") {
                const trimmed = additionnal.trim();
                if (!trimmed)
                    return [];
                try {
                    const parsed = JSON.parse(trimmed);
                    if (Array.isArray(parsed)) {
                        return parsed.filter((item) => (typeof item === "string" && item.trim().length > 0) ||
                            (item && typeof item === "object"));
                    }
                }
                catch (error) {
                }
            }
            return [];
        };
        const getOptionName = (option) => {
            if (!option)
                return "";
            return typeof option === "string" ? option : option.name || "";
        };
        const getOptionKey = (option) => {
            if (!option)
                return "";
            return typeof option === "string" ? option : option.id || option.name;
        };
        // Returns true if the option matches the selected option
        const isOptionSelected = (option) => {
            if (!selectedAdditionalOption.value)
                return false;
            // If string
            if (typeof option === "string")
                return selectedAdditionalOption.value === option;
            // If object
            if (typeof selectedAdditionalOption.value === 'object') {
                // Compare IDs if possible
                const selObj = selectedAdditionalOption.value;
                return selObj.id === option.id;
            }
            return false;
        };
        const additionalOptions = computed(() => {
            return parseAdditionalOptions(props.product?.additionnal);
        });
        const showIngredients = computed(() => {
            return (props.product?.type === "Pizza" ||
                (props.product?.ingredients && props.product.ingredients.length > 0));
        });
        const baseIngredients = computed(() => {
            if (props.product?.baseIngredients &&
                props.product.baseIngredients.length > 0) {
                return props.product.baseIngredients;
            }
            const product = props.product;
            if (product?.ingredientsBaseNames &&
                product.ingredientsBaseNames.length > 0) {
                const baseIngs = product.ingredientsBaseNames.map((name, index) => ({
                    id: `base-${index}`,
                    name: name,
                    isDefault: true,
                    isAvailable: true,
                    price: 0,
                    image: "/images/ingredients/default.png",
                    imageUrl: "/images/ingredients/default.png",
                }));
                return baseIngs;
            }
            return [];
        });
        const mapProductSizeToVariationSize = (productSizeName) => {
            const sizeName = productSizeName?.toLowerCase() || "";
            if (sizeName.includes("grande") || sizeName.includes("large")) {
                return "Grande";
            }
            if (sizeName.includes("normale") || sizeName.includes("normal")) {
                return "Normale";
            }
            return "unique";
        };
        const getIngredientPriceForSize = (ingredient, productSize) => {
            if (!ingredient || !productSize)
                return 0;
            if (ingredient.isDefault === true ||
                ingredient.id?.startsWith("base-")) {
                return 0;
            }
            if (ingredient.price_variations &&
                Array.isArray(ingredient.price_variations)) {
                let variationSize = "unique";
                if (typeof productSize === "object" && productSize.position !== undefined) {
                    // Priority 1: Map based on position
                    const positionMap = {
                        1: "Normale",
                        2: "Petite",
                        3: "Grande"
                    };
                    variationSize = positionMap[productSize.position] || "unique";
                }
                else {
                    // Priority 2: Fallback to name-based mapping
                    const sizeName = typeof productSize === "string" ? productSize : productSize.name;
                    variationSize = mapProductSizeToVariationSize(sizeName || "Normale");
                }
                let priceVariation = ingredient.price_variations.find((pv) => pv.size?.toLowerCase() === variationSize.toLowerCase());
                if (!priceVariation) {
                    if (variationSize === "Grande") {
                        priceVariation = ingredient.price_variations.find((pv) => pv.size?.toLowerCase() === "normale");
                    }
                    else if (variationSize === "Normale") {
                        priceVariation = ingredient.price_variations.find((pv) => pv.size?.toLowerCase() === "unique");
                    }
                }
                if (!priceVariation && ingredient.price_variations.length > 0) {
                    priceVariation = ingredient.price_variations[0];
                }
                if (priceVariation && typeof priceVariation.price === "number") {
                    return priceVariation.price;
                }
            }
            if (ingredient.extra_cost_price !== undefined) {
                return typeof ingredient.extra_cost_price === "number"
                    ? ingredient.extra_cost_price
                    : parseFloat(ingredient.extra_cost_price) || 0;
            }
            if (ingredient.price !== undefined) {
                return typeof ingredient.price === "number"
                    ? ingredient.price
                    : parseFloat(ingredient.price) || 0;
            }
            return 0;
        };
        const availableIngredients = computed(() => {
            const ingredients = [];
            const currentSizeName = selectedSize.value?.name || null;
            const baseIngredientIds = new Set(baseIngredients.value.map((ing) => ing.id));
            if (props.product?.ingredients && props.product.ingredients.length > 0) {
                const productIngredientsWithPrices = props.product.ingredients
                    .filter((ing) => ing.isAvailable && !baseIngredientIds.has(ing.id))
                    .map((ing) => {
                    const fullIngredient = allIngredients.value.find((i) => i.id === ing.id);
                    if (fullIngredient) {
                        const price = getIngredientPriceForSize(fullIngredient, selectedSize.value);
                        return {
                            ...ing,
                            price: price,
                            extra_cost_price: price,
                            price_variations: fullIngredient.price_variations,
                            type_position: fullIngredient.type_position,
                        };
                    }
                    const price = getIngredientPriceForSize(ing, selectedSize.value);
                    return {
                        ...ing,
                        price: price,
                        extra_cost_price: price,
                    };
                });
                ingredients.push(...productIngredientsWithPrices);
            }
            else {
                ingredients.push(...allIngredients.value
                    .filter((ing) => ing.is_available &&
                    !baseIngredientIds.has(ing.id) &&
                    !ing.id?.startsWith("base-"))
                    .map((ing) => {
                    const price = getIngredientPriceForSize(ing, selectedSize.value);
                    return {
                        id: ing.id,
                        name: ing.name,
                        image: ing.image_url,
                        isAvailable: ing.is_available,
                        isDefault: ing.is_default,
                        price: price,
                        extra_cost_price: price,
                        price_variations: ing.price_variations,
                        type: ing.type,
                        type_position: ing.type_position,
                    };
                }));
            }
            return ingredients;
        });
        const groupedIngredients = computed(() => {
            const groups = {};
            availableIngredients.value.forEach((ing) => {
                const type = ing.type;
                const typePosition = ing.type_position ?? 999;
                if (!groups[type]) {
                    groups[type] = {
                        type,
                        position: typePosition,
                        ingredients: [],
                    };
                }
                groups[type].ingredients.push(ing);
            });
            const sortedGroups = Object.values(groups).sort((a, b) => a.position - b.position);
            return sortedGroups;
        });
        const modifiedIngredients = computed(() => {
            const ingredients = [];
            const currentSizeName = selectedSize.value?.name || null;
            const baseIngredientIds = new Set(baseIngredients.value.map((ing) => ing.id));
            availableIngredients.value
                .filter((ing) => {
                return (selectedIngredients.value[ing.id] > 0 && !baseIngredientIds.has(ing.id));
            })
                .forEach((ing) => {
                let price = 0;
                const fullIngredient = allIngredients.value.find((i) => i.id === ing.id);
                if (fullIngredient) {
                    price = getIngredientPriceForSize(fullIngredient, selectedSize.value);
                }
                else {
                    price = getIngredientPriceForSize(ing, selectedSize.value);
                }
                ingredients.push({
                    ...ing,
                    quantity: selectedIngredients.value[ing.id],
                    price: price,
                });
            });
            return ingredients;
        });
        const hasModifications = computed(() => {
            return (modifiedIngredients.value.length > 0 ||
                removedBaseIngredients.value.size > 0 ||
                notes.value.trim() !== "");
        });
        const unitPrice = computed(() => {
            if (!selectedSize.value)
                return 0;
            const isDelivery = store.getters["orderType/isDelivery"];
            const basePrice = isDelivery && selectedSize.value.priceLivraison
                ? parseFloat(selectedSize.value.priceLivraison)
                : parseFloat(selectedSize.value.price);
            const ingredientsPrice = modifiedIngredients.value.reduce((sum, ing) => {
                return sum + ing.price * ing.quantity;
            }, 0);
            return basePrice + ingredientsPrice;
        });
        const totalPrice = computed(() => {
            return unitPrice.value * quantity.value;
        });
        const canAddToCart = computed(() => {
            return props.product && selectedSize.value && quantity.value > 0;
        });
        const loadIngredients = async () => {
            try {
                isLoadingIngredients.value = true;
                const [ingredientsResponse, typesResponse] = await Promise.all([
                    getAllIngredients(1, 100),
                    getIngredientTypes(),
                ]);
                if (ingredientsResponse.code === 200 && ingredientsResponse.data?.data) {
                    allIngredients.value = ingredientsResponse.data.data;
                }
                else {
                    allIngredients.value = [];
                }
                if (typesResponse.code === 200 && typesResponse.data) {
                    const data = typesResponse.data;
                    if (Array.isArray(data)) {
                        ingredientTypes.value = data.map((type) => {
                            if (typeof type === 'string') {
                                return { type, position: 999 };
                            }
                            const position = type.position !== null && type.position !== undefined
                                ? Number(type.position)
                                : 999;
                            return {
                                type: type.type || type.name || type,
                                position: isNaN(position) ? 999 : position,
                            };
                        });
                    }
                    else {
                        ingredientTypes.value = [];
                    }
                }
                else {
                    ingredientTypes.value = [];
                }
            }
            catch (error) {
                allIngredients.value = [];
                ingredientTypes.value = [];
            }
            finally {
                isLoadingIngredients.value = false;
            }
        };
        watch(() => props.product, async (newProduct) => {
            if (newProduct) {
                selectedAdditionalOption.value = "";
                await loadIngredients();
                if (props.initialSelectedSize) {
                    selectedSize.value = props.initialSelectedSize;
                }
                else if (newProduct.sizes && newProduct.sizes.length > 0) {
                    const preferredSize = newProduct.sizes.find((s) => s.name === "Normale" ||
                        s.name === "0,5L" ||
                        s.name === "0.5L" ||
                        s.name?.toLowerCase().includes("normale") ||
                        s.name?.toLowerCase().includes("0.5"));
                    if (preferredSize) {
                        selectedSize.value = preferredSize;
                    }
                    else {
                        const middleIndex = Math.floor(newProduct.sizes.length / 2);
                        selectedSize.value = newProduct.sizes[middleIndex];
                    }
                }
                const defaultIngredients = {};
                if (newProduct.ingredients) {
                    newProduct.ingredients.forEach((ing) => {
                        if (ing.isDefault && !ing.id.startsWith("base-")) {
                            defaultIngredients[ing.id] = 1;
                        }
                    });
                }
                else {
                    allIngredients.value.forEach((ing) => {
                        if (ing.is_default && !ing.id?.startsWith("base-")) {
                            defaultIngredients[ing.id] = 1;
                        }
                    });
                }
                selectedIngredients.value = defaultIngredients;
            }
        }, { immediate: true });
        const formatPrice = (price) => {
            const numPrice = typeof price === "string" ? parseFloat(price) : price;
            return isNaN(numPrice) ? "0.00" : numPrice.toFixed(2);
        };
        const getSizePrice = (size) => {
            const isDelivery = store.getters["orderType/isDelivery"];
            return isDelivery && size.priceLivraison
                ? parseFloat(size.priceLivraison)
                : parseFloat(size.price);
        };
        const selectSize = (size) => {
            selectedSize.value = size;
        };
        const getIngredientQuantity = (ingredientId) => {
            return selectedIngredients.value[ingredientId] || 0;
        };
        const toggleIngredient = (ingredient) => {
            const currentQty = getIngredientQuantity(ingredient.id);
            if (customizeMode.value === "add") {
                if (ingredient.isDefault) {
                    selectedIngredients.value[ingredient.id] = currentQty + 1;
                }
                else {
                    selectedIngredients.value[ingredient.id] =
                        currentQty > 0 ? currentQty + 1 : 1;
                }
            }
            else {
                if (ingredient.isDefault) {
                    selectedIngredients.value[ingredient.id] = 0;
                }
                else {
                    selectedIngredients.value[ingredient.id] = 0;
                }
            }
        };
        const removeBaseIngredient = (ingredient) => {
            if (ingredient.isDefault) {
                removedBaseIngredients.value.add(ingredient.id);
                delete selectedIngredients.value[ingredient.id];
            }
        };
        const increaseIngredient = (ingredientId) => {
            const currentQty = selectedIngredients.value[ingredientId] || 0;
            selectedIngredients.value[ingredientId] = currentQty + 1;
        };
        const decreaseIngredient = (ingredientId) => {
            const currentQty = selectedIngredients.value[ingredientId] || 0;
            if (currentQty > 0) {
                selectedIngredients.value[ingredientId] = currentQty - 1;
            }
        };
        const increaseQuantity = () => {
            quantity.value++;
        };
        const decreaseQuantity = () => {
            if (quantity.value > 1) {
                quantity.value--;
            }
        };
        const closeModal = () => {
            isOpen.value = false;
            selectedAdditionalOption.value = "";
            emit("close");
        };
        const addToCart = () => {
            if (!props.product || !selectedSize.value)
                return;
            const sizeWithOriginalPrices = {
                ...selectedSize.value,
                price: selectedSize.value.price,
                priceLivraison: selectedSize.value.priceLivraison,
            };
            const cartIngredients = modifiedIngredients.value.map((ing) => {
                const fullIngredient = allIngredients.value.find((i) => i.id === ing.id);
                const ingredientPrice = fullIngredient
                    ? getIngredientPriceForSize(fullIngredient, selectedSize.value)
                    : ing.price;
                return {
                    id: ing.id,
                    name: ing.name,
                    extra_cost_price: ingredientPrice,
                    quantity: ing.quantity,
                    isDefault: ing.isDefault,
                    size: selectedSize.value?.name || "Normale",
                    type: "ingredient",
                };
            });
            const removedBaseIngs = Array.from(removedBaseIngredients.value)
                .map((ingId) => {
                const ing = baseIngredients.value.find((i) => i.id === ingId);
                if (!ing)
                    return null;
                return {
                    id: ing.id,
                    name: ing.name,
                    extra_cost_price: 0,
                    quantity: 0,
                    isDefault: true,
                    size: selectedSize.value?.name || "Normale",
                    type: "ingredient",
                };
            })
                .filter((ing) => ing !== null);
            const addToCartEvent = {
                product: props.product,
                size: sizeWithOriginalPrices,
                quantity: quantity.value,
                ingredients: cartIngredients,
                removedIngredients: removedBaseIngs.length > 0 ? removedBaseIngs : undefined,
                supplements: [],
                additionnal: selectedAdditionalOption.value
                    ? [selectedAdditionalOption.value]
                    : [],
                notes: notes.value,
            };
            emit("add-to-cart", addToCartEvent);
            closeModal();
        };
        return (_ctx, _cache) => {
            return (isOpen.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "modal-overlay",
                    onClick: closeModal
                }, [
                    _createElementVNode("div", {
                        class: "modal-container",
                        onClick: _cache[6] || (_cache[6] = _withModifiers(() => { }, ["stop"]))
                    }, [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('pos.customizeProduct')), 1),
                            _createElementVNode("button", {
                                class: "close-btn",
                                onClick: closeModal
                            }, [...(_cache[7] || (_cache[7] = [
                                    _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                                ]))])
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("img", {
                                        src: __props.product?.image || '/images/default-product.jpg',
                                        alt: __props.product?.name
                                    }, null, 8, _hoisted_6)
                                ]),
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("h3", _hoisted_8, _toDisplayString(__props.product?.name), 1),
                                    (__props.product?.description)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(__props.product.description), 1))
                                        : _createCommentVNode("", true),
                                    (__props.product?.sizes && __props.product.sizes.length > 1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                            _createElementVNode("h4", _hoisted_11, _toDisplayString(_ctx.$t('pos.chooseSize')), 1),
                                            _createElementVNode("div", _hoisted_12, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.product.sizes, (size) => {
                                                    return (_openBlock(), _createElementBlock("button", {
                                                        key: size.id,
                                                        class: _normalizeClass([
                                                            'size-btn',
                                                            { active: selectedSize.value?.id === size.id },
                                                        ]),
                                                        onClick: ($event) => (selectSize(size))
                                                    }, [
                                                        _createElementVNode("span", _hoisted_14, _toDisplayString(size.name), 1),
                                                        _createElementVNode("span", _hoisted_15, _toDisplayString(formatPrice(getSizePrice(size))) + " CHF", 1)
                                                    ], 10, _hoisted_13));
                                                }), 128))
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            (showIngredients.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                    _createElementVNode("h4", _hoisted_17, _toDisplayString(_ctx.$t('pos.customizeIngredients')), 1),
                                    _cache[17] || (_cache[17] = _createStaticVNode("<div class=\"ingredients-info\" data-v-00831634><div class=\"info-item\" data-v-00831634><i class=\"fas fa-check-circle\" style=\"color:#388d35;\" data-v-00831634></i><span data-v-00831634>Les ingrédients marqués &quot;Inclus&quot; viennent avec le produit</span></div><div class=\"info-item\" data-v-00831634><i class=\"fas fa-plus\" style=\"color:#388d35;\" data-v-00831634></i><span data-v-00831634>Mode Ajouter : ajoutez des ingrédients supplémentaires</span></div><div class=\"info-item\" data-v-00831634><i class=\"fas fa-minus\" style=\"color:#ef4444;\" data-v-00831634></i><span data-v-00831634>Mode Retirer : retirez même les ingrédients inclus</span></div></div>", 1)),
                                    _createElementVNode("div", _hoisted_18, [
                                        _createElementVNode("button", {
                                            class: _normalizeClass(['mode-btn', { active: customizeMode.value === 'add' }]),
                                            onClick: _cache[0] || (_cache[0] = ($event) => (customizeMode.value = 'add'))
                                        }, [
                                            _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fas fa-plus" }, null, -1)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('pos.add')), 1)
                                        ], 2),
                                        _createElementVNode("button", {
                                            class: _normalizeClass(['mode-btn', { active: customizeMode.value === 'remove' }]),
                                            onClick: _cache[1] || (_cache[1] = ($event) => (customizeMode.value = 'remove'))
                                        }, [
                                            _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fas fa-minus" }, null, -1)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('pos.remove')), 1)
                                        ], 2)
                                    ]),
                                    (baseIngredients.value.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                            _createElementVNode("div", _hoisted_20, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseIngredients.value.filter((ing) => !removedBaseIngredients.value.has(ing.id)), (ingredient) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: ingredient.id,
                                                        class: _normalizeClass([
                                                            'ingredient-item',
                                                            {
                                                                'default-ingredient': true,
                                                            },
                                                        ])
                                                    }, [
                                                        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "default-badge" }, [
                                                            _createElementVNode("i", { class: "fas fa-check-circle" }),
                                                            _createElementVNode("span", null, "Inclus")
                                                        ], -1)),
                                                        _createElementVNode("div", _hoisted_21, [
                                                            _createElementVNode("img", {
                                                                src: ingredient.image || ingredient.imageUrl || '/images/ingredients/default.png',
                                                                alt: ingredient.name
                                                            }, null, 8, _hoisted_22)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_23, [
                                                            _createElementVNode("span", _hoisted_24, _toDisplayString(ingredient.name), 1),
                                                            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "ingredient-price default-price" }, "Inclus", -1))
                                                        ]),
                                                        _createElementVNode("div", _hoisted_25, [
                                                            _createElementVNode("button", {
                                                                onClick: _withModifiers(($event) => (removeBaseIngredient(ingredient)), ["stop"]),
                                                                onMousedown: _cache[2] || (_cache[2] = _withModifiers(() => { }, ["stop"])),
                                                                onMouseup: _cache[3] || (_cache[3] = _withModifiers(() => { }, ["stop"])),
                                                                class: "remove-base-btn",
                                                                title: "Retirer cet ingrédient",
                                                                style: { "z-index": "1000", "position": "relative" }
                                                            }, [...(_cache[11] || (_cache[11] = [
                                                                    _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                                                                ]))], 40, _hoisted_26)
                                                        ])
                                                    ]));
                                                }), 128))
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedIngredients.value, (group) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: group.type,
                                            class: "ingredient-group"
                                        }, [
                                            _createElementVNode("h5", _hoisted_27, _toDisplayString(group.type), 1),
                                            _createElementVNode("div", _hoisted_28, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.ingredients, (ingredient) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: ingredient.id,
                                                        class: _normalizeClass([
                                                            'ingredient-item',
                                                            {
                                                                'default-ingredient': ingredient.isDefault,
                                                                'removed-default': ingredient.isDefault &&
                                                                    getIngredientQuantity(ingredient.id) === 0,
                                                                selected: getIngredientQuantity(ingredient.id) > 0,
                                                            },
                                                        ]),
                                                        onClick: ($event) => (toggleIngredient(ingredient))
                                                    }, [
                                                        (ingredient.isDefault)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [...(_cache[13] || (_cache[13] = [
                                                                    _createElementVNode("i", { class: "fas fa-check-circle" }, null, -1),
                                                                    _createElementVNode("span", null, "Inclus", -1)
                                                                ]))]))
                                                            : _createCommentVNode("", true),
                                                        _createElementVNode("div", _hoisted_31, [
                                                            _createElementVNode("img", {
                                                                src: ingredient.image || ingredient.imageUrl || '/images/ingredients/default.png',
                                                                alt: ingredient.name
                                                            }, null, 8, _hoisted_32),
                                                            (ingredient.isDefault &&
                                                                getIngredientQuantity(ingredient.id) === 0)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [...(_cache[14] || (_cache[14] = [
                                                                        _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                                                                    ]))]))
                                                                : _createCommentVNode("", true)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_34, [
                                                            _createElementVNode("span", _hoisted_35, _toDisplayString(ingredient.name), 1),
                                                            (!ingredient.isDefault)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                                                                    (getIngredientPriceForSize(ingredient, selectedSize.value?.name || null) > 0)
                                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                            _createTextVNode(" +" + _toDisplayString(formatPrice(getIngredientPriceForSize(ingredient, selectedSize.value))) + " CHF ", 1)
                                                                        ], 64))
                                                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                            _createTextVNode(" Gratuit ")
                                                                        ], 64))
                                                                ]))
                                                                : (ingredient.isDefault)
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_37, "Inclus"))
                                                                    : _createCommentVNode("", true)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_38, [
                                                            (getIngredientQuantity(ingredient.id) > 0)
                                                                ? (_openBlock(), _createElementBlock("button", {
                                                                    key: 0,
                                                                    class: "qty-btn decrease",
                                                                    onClick: _withModifiers(($event) => (decreaseIngredient(ingredient.id)), ["stop"])
                                                                }, [...(_cache[15] || (_cache[15] = [
                                                                        _createElementVNode("i", { class: "fas fa-minus" }, null, -1)
                                                                    ]))], 8, _hoisted_39))
                                                                : _createCommentVNode("", true),
                                                            (getIngredientQuantity(ingredient.id) > 0)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(getIngredientQuantity(ingredient.id)), 1))
                                                                : _createCommentVNode("", true),
                                                            _createElementVNode("button", {
                                                                class: "qty-btn increase",
                                                                onClick: _withModifiers(($event) => (increaseIngredient(ingredient.id)), ["stop"])
                                                            }, [...(_cache[16] || (_cache[16] = [
                                                                    _createElementVNode("i", { class: "fas fa-plus" }, null, -1)
                                                                ]))], 8, _hoisted_41)
                                                        ])
                                                    ], 10, _hoisted_29));
                                                }), 128))
                                            ])
                                        ]));
                                    }), 128))
                                ]))
                                : _createCommentVNode("", true),
                            (additionalOptions.value.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                    _createElementVNode("h4", _hoisted_43, _toDisplayString(_unref(t)('pos.additionalOptions')), 1),
                                    _createElementVNode("p", _hoisted_44, _toDisplayString(_unref(t)('pos.selectOneOption')), 1),
                                    _createElementVNode("div", _hoisted_45, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(additionalOptions.value, (option) => {
                                            return (_openBlock(), _createElementBlock("label", {
                                                key: getOptionKey(option),
                                                class: _normalizeClass(["additional-option-card", { selected: isOptionSelected(option) }])
                                            }, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "radio",
                                                    value: option,
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((selectedAdditionalOption).value = $event)),
                                                    class: "option-radio"
                                                }, null, 8, _hoisted_46), [
                                                    [_vModelRadio, selectedAdditionalOption.value]
                                                ]),
                                                _createElementVNode("span", _hoisted_47, _toDisplayString(getOptionName(option)), 1),
                                                _createElementVNode("i", {
                                                    class: _normalizeClass([
                                                        isOptionSelected(option)
                                                            ? 'fas fa-dot-circle'
                                                            : 'far fa-circle',
                                                        "option-icon"
                                                    ])
                                                }, null, 2)
                                            ], 2));
                                        }), 128))
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_48, [
                                _cache[18] || (_cache[18] = _createElementVNode("h4", { class: "selection-title" }, "Instructions spéciales", -1)),
                                _withDirectives(_createElementVNode("textarea", {
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((notes).value = $event)),
                                    placeholder: _ctx.$t('pos.addSpecialInstructions'),
                                    class: "notes-input",
                                    rows: "3"
                                }, null, 8, _hoisted_49), [
                                    [_vModelText, notes.value]
                                ])
                            ]),
                            (hasModifications.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                    _cache[19] || (_cache[19] = _createElementVNode("h4", { class: "selection-title" }, "Vos modifications", -1)),
                                    _createElementVNode("div", _hoisted_51, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modifiedIngredients.value, (ingredient) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: ingredient.id,
                                                class: "modification-item"
                                            }, [
                                                _createElementVNode("span", _hoisted_52, _toDisplayString(ingredient.name), 1),
                                                _createElementVNode("span", _hoisted_53, "x" + _toDisplayString(ingredient.quantity), 1),
                                                _createElementVNode("span", _hoisted_54, "+" + _toDisplayString(formatPrice(ingredient.price * ingredient.quantity)) + " CHF", 1)
                                            ]));
                                        }), 128))
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("div", _hoisted_56, [
                                _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.$t('common.quantity')) + ":", 1),
                                _createElementVNode("div", _hoisted_58, [
                                    _createElementVNode("button", {
                                        class: "qty-btn",
                                        onClick: decreaseQuantity,
                                        disabled: quantity.value <= 1
                                    }, [...(_cache[20] || (_cache[20] = [
                                            _createElementVNode("i", { class: "fas fa-minus" }, null, -1)
                                        ]))], 8, _hoisted_59),
                                    _createElementVNode("span", _hoisted_60, _toDisplayString(quantity.value), 1),
                                    _createElementVNode("button", {
                                        class: "qty-btn",
                                        onClick: increaseQuantity
                                    }, [...(_cache[21] || (_cache[21] = [
                                            _createElementVNode("i", { class: "fas fa-plus" }, null, -1)
                                        ]))])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_61, [
                                _createElementVNode("div", _hoisted_62, [
                                    _cache[22] || (_cache[22] = _createElementVNode("span", { class: "price-label" }, "Prix unitaire:", -1)),
                                    _createElementVNode("span", _hoisted_63, _toDisplayString(formatPrice(unitPrice.value)) + " CHF", 1)
                                ]),
                                _createElementVNode("div", _hoisted_64, [
                                    _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.$t('common.total')) + ":", 1),
                                    _createElementVNode("span", _hoisted_66, _toDisplayString(formatPrice(totalPrice.value)) + " CHF", 1)
                                ])
                            ]),
                            _createElementVNode("button", {
                                class: "add-to-cart-btn",
                                onClick: addToCart,
                                disabled: !canAddToCart.value
                            }, [
                                _cache[23] || (_cache[23] = _createElementVNode("i", { class: "fas fa-shopping-cart" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('pos.addToCart')), 1)
                            ], 8, _hoisted_67)
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
